.message {
  flex: 1;
  min-width: 0;
}

.author {
  flex-shrink: 0;
}
